import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { Subject } from 'rxjs'
import { formatTimeStamp } from '@/utils/time'
import { ParamsClean } from '@/common/decorators/params-clean'

export enum RankType {
  duration = 1,
  useSoftCount = 2,
  softCount = 3
}

/** RankCard 标题 i18n 键（排行档位用 common.rankTagTop15 标签展示） */
export const rankCardTitleI18nKey: Record<RankType, string> = {
  [RankType.duration]: 'genuineSoftwareUsage.rankAuthTerminalDuration',
  [RankType.useSoftCount]: 'genuineSoftwareUsage.rankAuthTerminalUseCount',
  [RankType.softCount]: 'genuineSoftwareUsage.rankAuthTerminalSoftCount'
}

/** 终端视图排行饼图 series.name */
export const rankCardSeriesNameI18nKey: Record<RankType, string> = {
  [RankType.duration]: 'genuineSoftwareUsage.rankSeriesTerminalDuration',
  [RankType.useSoftCount]: 'genuineSoftwareUsage.rankSeriesTerminalUseCount',
  [RankType.softCount]: 'genuineSoftwareUsage.rankSeriesTerminalSoftUsed'
}

export interface SoftwareUsageReq {
  /** 开始时间（秒，字符串或数字与网关约定一致） */
  start_time?: string | number
  /** 结束时间 */
  end_time?: string | number
  /** 第几页 */
  page?: number
  /** 每页多少条 */
  limit?: number
  /** 是否升序 */
  asc?: boolean
  /** 是否只查正版软件 0-全部 1-是 2-否 */
  authenticsoft_flag?: number
  /** 终端分组id */
  group_id?: number
  /** 系统类型：1-windows，2-linux，3-server，4-mac；不传表示全部 */
  system_type?: number
  /** 计算机|登记用户名|ip地址 */
  key_word?: string
  /** 排序字段 */
  sort?: string
  soft_hash_key?: string
  /** 仅含已授权正版软件的终端等场景：传 1 */
  has_authorized_soft?: number
}

/** `/softmgr/userecord/auth-soft-terminal-list` 单行，兼容旧 `/terminal-list` 字段名 */
export interface AuthenticTerminalListItem {
   /** 计算机名 */
  computer_name: string
  /** 登记用户名 */
  user_mark: string
  /** 分组名 */
  group_name: string
  /** 外网IP */
  client_ip: string
  /** 内网IP */
  system_ip: string
  /** 终端id */
  device_id: string
  /** 系统类型,1-windows,2-linux, 3-server 4-mac */
  system_type: number
  /** 登录状态,1-在线，0/2-离线（兼容接口差异） */
  login_status: number
  authorized_soft_count: number
  unauthorized_soft_count: number
}



@Injectable()
export class TerminalViewService {
  updateEvent = new Subject()

  constructor (private http: Http) {
  }

  @InvokeThrottle()
  @ParamsClean()
  getSoftwareUsage (data: SoftwareUsageReq) {
    return this.http.post<{ list: AuthenticTerminalListItem[]; total: number }>('/softmgr/userecord/auth-soft-terminal-list', data)
  }
  download (type: 0|1, options: SoftwareUsageReq, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/softmgr/userecord/auth-soft-terminal-list/export', params, moduleName)
  }
}
